import './InvitesTabStyle.css';
import './SeasonsTabStyle.css';
import { useEffect, useState } from "react";
import SubTabParent from "../../../../_shoru_shared_library/components/console_page/sub_tab/SubTabParent";
import SubTabSection from "../../../../_shoru_shared_library/components/console_page/sub_tab/SubTabSection";
import { CheckBoxOutlineBlank, ToggleOff, ToggleOn } from '@mui/icons-material';
import SubTabNoData from '../../../../_shoru_shared_library/components/console_page/sub_tab/SubTabNoData';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from '../../../../_shoru_shared_library/firebase/firebase_setup';
import FormInput from '../../../../_shoru_shared_library/components/form/FormInput';

export function SeasonsTab(props) {

  const [seasons, setSeasons] = useState(props.organisationData.seasons);
  const [activeSeasons, setActiveSeasons] = useState([]);
  const [inactiveSeasons, setInactiveSeasons] = useState([]);
  const [open, setOpen] = useState(false);

  const userData = props.userData;

  useEffect(() => {
    setSeasons(props.organisationData.seasons);
    setActiveSeasons(props.organisationData.seasons.filter((x) => x.active));
    setInactiveSeasons(props.organisationData.seasons.filter((x) => !x.active));
  }, [props.organisationData]);

  const handleUpdateSeasons = async(newSeasons) => {
    const docRef = doc(db, userData.active_organisation_id, 'organisation-data');
    try {
      await setDoc(docRef, {seasons: newSeasons}, {merge: true});
      const docSnap = await getDoc(docRef);
      const data = docSnap.data();
      props.setOrganisationData(data);
    }
    catch(err) {
      console.error(err);
      alert('Could not update seasons. Please try again.');
    }
  }

  const handleToggleActive = async(uid) => {
    const newSeasons = seasons.map((s) => {
      return {
        uid: s.uid,
        name: s.name,
        active: s.uid === uid ? !s.active : s.active
      }
    });
    handleUpdateSeasons(newSeasons);
  }

  return (
    <SubTabParent passData={props}>

      {
        open 
        ? <CreateSeasonMenu 
            seasons={seasons}
            userData={userData}
            setOpen={setOpen} 
            accentColour={props.accentColour}
            handleUpdateSeasons={handleUpdateSeasons}
          />
        : <div />
      }

      <SubTabSection no_background>
        <div className='create-season'>
          <button style={{backgroundColor: props.accentColour, width: '100%'}} onClick={() => setOpen(true)}>Create New Season</button>
        </div>
      </SubTabSection>

      {
        seasons.length 
        ? <div>
            <SubTabSection title='Active Seasons' description='Seasons you are currently running.'>
              <SeasonList 
                seasons={activeSeasons}
                handleToggleActive={handleToggleActive}
              />
            </SubTabSection>
            <SubTabSection title='Inactive Seasons' description='Seasons no longer being run. These are hidden from filters and ClashBot. Shows in inactive seasons cannot be accessed.'>
              <SeasonList 
                seasons={inactiveSeasons}
                handleToggleActive={handleToggleActive}
              />
            </SubTabSection>
          </div>
        : <SubTabNoData title='No Seasons' description='' icon={<CheckBoxOutlineBlank />} />
      }

    </SubTabParent>
  )

}


function SeasonList({seasons, handleToggleActive}) {

  const sorted = seasons.sort((a, b) => {
    return b.name.localeCompare(a.name);
  });

  return (
    <div className='invite-list'>
      {
        sorted.map((s) => {
          return (
            <div key={s.uid} className='invite-list-item' style={{paddingTop: s.active ? '20px' : '10px', paddingBottom: s.active ? '20px' : '10px'}}>
              <div className='invite-list-name'>
                <div>{s.name}</div>
              </div>
              <div className='season-list-toggle'>
                {
                  s.active 
                  ? <ToggleOn onClick={() => handleToggleActive(s.uid)} fontSize='large' style={{color: '#2ecc71'}} />
                  : <ToggleOff onClick={() => handleToggleActive(s.uid)} fontSize='large' />
                }
              </div>
            </div>
          )

        }
        )
      }
    </div>
  )

}


function CreateSeasonMenu({seasons, userData, setOpen, accentColour, handleUpdateSeasons}) {

  const [name, setName] = useState('');

  const [isCreating, setIsCreating] = useState(false);

  const handleClose = () => {
    setOpen(false);
  }

  const handleCreate = async() => {
    setIsCreating(true);

    if(!name) {
      alert('Please fill out all required fields');
      setIsCreating(false);
      return;
    }

    const uid = name.toLowerCase().trim().replaceAll(' ','-').replace(/[&\/\\#,+()$~%.'’":!*?<>{}]/g, '');
    const alreadyExists = seasons.filter((x) => x.uid === uid).length;
    if(alreadyExists) {
      alert('A season with this name already exists');
      setIsCreating(false);
      return;
    }

    const season = {
      uid: uid,
      name: name,
      active: true
    }

    try {
      const newSeasons = [...seasons, season];
      await handleUpdateSeasons(newSeasons);
      handleClose();
    }
    catch(err) {
      alert('Could not create invite, please try again');
      console.error(err);
      setIsCreating(false);
    }
  }

  return (
    <div className='create-invite-container'>
      <div className='create-invite-background' onClick={handleClose}>
        <div className='create-invite-menu' onClick={(e) => e.stopPropagation()}>
          <h2>Create New Season</h2>
          <div className='create-invite-form'>
            <FormInput required title='Season Name' value={name} setValue={setName} disabled={isCreating} placeholder='e.g. Spring 2026' />
            <p className='create-invite-disclaimer'>Once created, seasons CANNOT be changed or removed. Please ensure the spelling/formatting is correct.</p>
            <button style={{backgroundColor: accentColour, width: '100%'}} onClick={handleCreate}>Create Season</button>
          </div>
        </div>
      </div>
    </div>
  )
}